import api from '../../utilities/api';

export const fetchLocationOverview = async () => {
    const response = await api.get('/api/location/overview');
    return response.data.data;
}

export const fetchCountries = async () => {
    // We can get country list from overview stats or separate endpoint.
    // For now, let's assume we extract it from overview or fetch distinct.
    // If overview returns countryData, we can use that.
    return [];
}
